import Cookies from 'js-cookie'
import api from '../api'

const gitBranch = process.env.GIT_BRANCH.split('/')
const envIndex = gitBranch && gitBranch[0] === 'release' ? 1 : 0
const isStaging = gitBranch && gitBranch[envIndex] === 'staging' && 'staging'
const isStable = gitBranch && gitBranch[envIndex] === 'stable' && 'stable'

class RegilyIdExchange {
  constructor () {
    this.domainOrigin = this.getDomainOrigin(window.location.origin)
  }

  generateUUID () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      const randomNumber = Math.random() * 16 | 0
      const valid = char === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8)
      return valid.toString(16)
    })
  }

  // Set Cookie on first-party website (partner website)
  setFirstPartyCookie () {
    try {
      let cookieValue = Cookies.get(`regilyUserId`)
      if (!cookieValue) {
        cookieValue = this.generateUUID()
        Cookies.set(`regilyUserId`, cookieValue, { expires: 365, domain: this.domainOrigin })
      }

      return cookieValue
    } catch (e) {
      console.log('Failed to set Cookies')
    }
  }

  // Set|Get cookie from regily.com|io website
  setThirdPartyCookie (opt) {
    try {
      let regilyDomainOrigin = this.domainOrigin
      // Get|Set cookie on "regily.com" instead of using "partnerX.regily.com"
      if ((regilyDomainOrigin.split('.').length - 1) > 1) {
        const firstDotIndex = regilyDomainOrigin.indexOf('.')
        regilyDomainOrigin = regilyDomainOrigin.substring(firstDotIndex + 1)
      }

      const regilyCookie = Cookies.get(`regilyUserId`, { domain: regilyDomainOrigin })

      if (!regilyCookie) {
        Cookies.set(`regilyUserId`, opt.regilyIdCookieValue, { expires: 365, domain: regilyDomainOrigin })
      } else {
        window.parent.postMessage({ regilyCookie }, opt.parentOrigin)
      }

      RegilyIdExchange.prototype.regilyUserId = regilyCookie || Cookies.get(`regilyUserId`, { domain: regilyDomainOrigin })
    } catch (e) {
      console.log('Failed to set Cookies')
    }
  }

  getDomainOrigin (origin) {
    return origin.substr(origin.indexOf('://') + 3).replace(/:.*$/, '')
  }

  refreshCookie (cookieValue) {
    try {
      Cookies.remove('regilyUserId', { domain: this.domainOrigin })
      setTimeout(() => {
        Cookies.set('regilyUserId', cookieValue, { expires: 365, domain: this.domainOrigin })
      }, 100)
    } catch (e) {
      console.log('Failed to refresh Cookies')
    }
  }

  iframeCookieListener (iframeUrl) {
    try {
      this.iframeUrl = iframeUrl
      window.addEventListener('message', this.cookieListenerHandler.bind(this), new URL(this.iframeUrl).origin)
    } catch (e) { }
  }

  cookieListenerHandler (event) {
    if (event.data && event.data.regilyCookie) {
      this.refreshCookie(event.data.regilyCookie)
      this.removeCookieListener()
    }
  }

  removeCookieListener () {
    window.removeEventListener('message', this.cookieListenerHandler, new URL(this.iframeUrl).origin)
  }

  trackUserIdExchange (action, partner) {
    try {
      const userId = RegilyIdExchange.prototype.regilyUserId
      if (!userId) return

      api.metadataIdExchange.create({
        idExchange: {
          userId: userId,
          partnerId: partner.partnerId,
          partnerName: partner.partnerName,
          action: action,
          environment: isStable || isStaging || 'unknown',
          userAgent: navigator.userAgent || ''
        }
      })
    } catch (e) {}
  }
}

export default new RegilyIdExchange()



// WEBPACK FOOTER //
// ./src/utils/RegilyIdExchange.js